import { render, staticRenderFns } from "./ConfirmRecord.vue?vue&type=template&id=71cfba5e&"
import script from "./ConfirmRecord.vue?vue&type=script&lang=js&"
export * from "./ConfirmRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports